import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
export var extractVersionNumber = function extractVersionNumber(str) {
  var regex = /\d+/; // regular expression to match digits
  var match = str.match(regex); // search for first occurrence of digits
  if (match) {
    return match[0]; // convert matched digits to a string
  } else {
    return null; // return null if no digits found in string
  }
};